import {Offer} from 'models/Offer';

export interface PaginatedOffers {
  [numColumns: number]: {
    [page: number]: Offer[];
    totalPages: number;
  };
}

/**
 * Helper function for filtered or see more grouping of offers to create paginated offers
 * @param offers List of offers to make a paginated object with
 * @param numRows The number of rows per page
 * @returns A paginated object to be used in rendering of filtered or see more offers
 */
export const paginateOffers = (
  offers: Offer[],
  numRows = 5
): PaginatedOffers => {
  const result: PaginatedOffers = {};

  if (offers.length === 0) {
    return result;
  }

  /**
   * For each of the num columns (i.e breakpoint size)
   * calculate the total pages we'll need for that breakpoint,
   * and the associating pages of offers.
   */
  for (let numCols = 1; numCols < 5; numCols++) {
    const numPerPage = numCols * numRows;
    const totalPages = Math.ceil(offers.length / numPerPage);
    result[numCols] = {totalPages};

    /**
     * For the totalPages we have,
     * slice up the offers array into their respective pages
     */
    let page, i, j;
    for (
      page = 0, i = 0, j = offers.length;
      i < j;
      i += numPerPage, page += 1
    ) {
      result[numCols][page] = offers.slice(i, i + numPerPage);
    }
  }

  return result;
};
